import {
  Button,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import React from "react";
import { BiChevronDown } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../lib/auth";
import { CiSettings } from "react-icons/ci";

export const SettingsNavBar = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const signOutAndGoToLogin = () => {
    signOut();
    navigate("/login");
  };

  const accountMenuItems = [
    { label: "Sign out", action: () => signOutAndGoToLogin() },
  ];

  return (
    <Menu variant={"settingsMenu"} placement={"bottom"}>
      <MenuButton
        as={Button}
        display={"flex"}
        leftIcon={<Icon as={CiSettings} w={5} h={5} />}
        rightIcon={<Icon as={BiChevronDown} w={5} h={5} />}
        variant={"accountMenu"}
        textAlign="left"
        color="muted"
        width={"100%"}
        fontWeight="semibold"
        fontSize="13px"
      >
        {"Settings"}
      </MenuButton>
      <MenuList justifyContent="flex-start">
        {accountMenuItems.map(({ label, action }, ix) => {
          return (
            <MenuItem
              justifyContent="flex-start"
              key={`${label}-${ix}`}
              onClick={action}
            >
              {label}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
